<template>
    <section class="expertises section-padding" id="Nos-expertises">
        <div class="add-padding hero-banner-ten">
            <h2 class="titre-section ">
                <span class="span-background-blue">
                    Nos expertises
                </span>
            </h2>
            <div class="box-card">
                <a class="conseil" href="/conseil_rh/pcrh">
                    <i>
                        <svg width="81" height="64" viewBox="0 0 81 64" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M34.25 38C46.25 38 56 47.75 56 59.75C56 62.125 54 64 51.625 64H4.25C1.875 64 0 62.125 0 59.75C0 47.75 9.625 38 21.625 38H34.25ZM51.625 60C51.75 60 52 59.875 52 59.75C52 50 44 42 34.25 42H21.625C11.875 42 4 50 4 59.75C4 59.875 4.125 60 4.25 60H51.625ZM28 32C19.125 32 12 24.875 12 16C12 7.25 19.125 0 28 0C36.75 0 44 7.25 44 16C44 24.875 36.75 32 28 32ZM28 4C21.375 4 16 9.5 16 16C16 22.625 21.375 28 28 28C34.5 28 40 22.625 40 16C40 9.5 34.5 4 28 4ZM79.375 19.25C80.125 20.125 80.125 21.375 79.375 22.125L66 35.5C65.625 35.875 65.125 36 64.625 36C64.125 36 63.625 35.875 63.25 35.5L56.5 28.75C55.75 28 55.75 26.75 56.5 26C57.25 25.25 58.625 25.25 59.375 26L64.625 31.25L76.5 19.25C77.25 18.5 78.625 18.5 79.375 19.25Z" />
                        </svg>
                    </i>
                    <div class="box-content">
                        <h3 class="title">
                            Conseil RH
                        </h3>
                        <p class="sous-titre">
                            PCRH, Marque employeur, Entretien annuel et professionnel, Obligations légales, GEPP...
                        </p>
                    </div>
                </a>
                <a class="qualite" href="/qualite-vie-condition-travail/prevention-rps">
                    <i>
                        <svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M86.375 60.875C87.625 61.625 88.25 63.25 87.75 64.625C86.875 67.375 85.5 69.875 83.625 72C82.625 73 80.875 73.25 79.625 72.625L77.5 71.375C76.625 72 75.625 72.5 74.625 73V75.375C74.625 76.875 73.625 78.25 72.125 78.5C70.75 78.875 69.375 79 67.875 79C66.5 79 65.125 78.875 63.75 78.5C62.25 78.25 61.25 76.875 61.25 75.375V73C60.25 72.5 59.25 72 58.375 71.375L56.25 72.625C55 73.25 53.25 73 52.25 71.875C50.375 69.875 49 67.375 48.125 64.625C47.625 63.25 48.25 61.625 49.5 60.875L51.625 59.75C51.625 59.125 51.5 58.625 51.5 58.125C51.5 57.5 51.625 57 51.625 56.375L49.5 55.25C48.25 54.5 47.625 52.875 48.125 51.5C49 48.75 50.375 46.25 52.25 44.125C53.25 43.125 55 42.875 56.25 43.5L58.375 44.75C59.25 44.125 60.25 43.625 61.25 43.25V40.75C61.25 39.25 62.25 37.875 63.75 37.625C66.5 37 69.375 37 72.125 37.625C73.625 37.875 74.625 39.25 74.625 40.75V43.25C75.625 43.625 76.625 44.125 77.5 44.75L79.625 43.5C80.875 42.875 82.625 43.125 83.625 44.125C85.5 46.25 86.875 48.75 87.75 51.5C88.25 52.875 87.625 54.5 86.375 55.25L84.25 56.375C84.25 57 84.375 57.5 84.375 58.125C84.375 58.625 84.25 59.125 84.25 59.75L86.375 60.875ZM80.125 55.75L79.875 54.375L83.75 52.125C83.125 50.375 82.25 48.75 81 47.375L77 49.625L76 48.75C74.75 47.75 73.5 47 72 46.375L70.625 46V41.375C68.875 41 67 41 65.25 41.375V46L63.875 46.375C62.375 47 61.125 47.75 59.875 48.75L58.875 49.625L54.875 47.375C53.625 48.75 52.75 50.375 52.125 52.125L56 54.375L55.75 55.75C55.625 56.5 55.5 57.25 55.5 58.125C55.5 58.875 55.625 59.625 55.75 60.375L56 61.75L52.125 64C52.75 65.75 53.625 67.375 54.875 68.75L58.75 66.5L59.875 67.375C61 68.5 62.375 69.25 63.875 69.75L65.25 70.25V74.75C67 75.125 68.875 75.125 70.625 74.75V70.25L72 69.75C73.5 69.25 74.875 68.5 76 67.375L77.125 66.5L81 68.75C82.25 67.375 83.125 65.75 83.75 64L79.875 61.75L80.125 60.375C80.25 59.625 80.375 58.875 80.375 58.125C80.375 57.25 80.25 56.5 80.125 55.75ZM68 51C71.75 51 74.875 54.25 74.875 58C74.875 61.875 71.625 65 68 65C64.25 65 61 61.875 61 58C61 54.25 64.125 51 68 51ZM68 61C69.625 61 70.875 59.75 70.875 58C70.875 56.375 69.625 55 68 55C66.25 55 65 56.375 65 58C65 59.75 66.25 61 68 61ZM54 76C55 76 56 77 56 78C56 79.125 55 80 54 80H12.25C9.875 80 8 78.125 8 75.75C7.875 63.75 17.625 54 29.625 54H42C43 54 44 55 44 56C44 57.125 43 58 42 58H29.625C19.875 58 11.875 66 12 75.75C12 75.875 12.125 76 12.25 76H54ZM36 48C27.125 48 20 40.875 20 32C20 23.25 27.125 16 36 16C44.75 16 52 23.25 52 32C52 40.875 44.75 48 36 48ZM36 20C29.375 20 24 25.5 24 32C24 38.625 29.375 44 36 44C42.5 44 48 38.625 48 32C48 25.5 42.5 20 36 20Z" />
                        </svg>
                    </i>
                    <div class="box-content">
                        <h3 class="title">
                            Qualité de vie et conditions de travail
                        </h3>
                        <p class="sous-titre">
                            Audit social, GAP, Supervision, Médiation, Prévention RPS...
                        </p>
                    </div>
                </a>
                <a class="management" href="/management/accompagnement_codir">
                    <i>
                        <svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M22.5 68C27.625 68 32 72.5 32 78C32 79.125 31 80 30 80C28.875 80 28 79.125 28 78C28 74.75 25.5 72 22.5 72H17.5C14.375 72 12 74.75 12 78C12 79.125 11 80 10 80C8.875 80 8 79.125 8 78C8 72.5 12.25 68 17.5 68H22.5ZM78.5 68C83.625 68 88 72.5 88 78C88 79.125 87 80 86 80C84.875 80 84 79.125 84 78C84 74.75 81.5 72 78.5 72H73.5C70.375 72 68 74.75 68 78C68 79.125 67 80 66 80C64.875 80 64 79.125 64 78C64 72.5 68.25 68 73.5 68H78.5ZM50.5 68C55.625 68 60 72.5 60 78C60 79.125 59 80 58 80C56.875 80 56 79.125 56 78C56 74.75 53.5 72 50.5 72H45.5C42.375 72 40 74.75 40 78C40 79.125 39 80 38 80C36.875 80 36 79.125 36 78C36 72.5 40.25 68 45.5 68H50.5ZM40 56C40 51.625 43.5 48 48 48C52.375 48 55.875 51.625 55.875 56C55.875 60.5 52.375 64 47.875 64C43.5 64 40 60.5 40 56ZM52 56C52 53.875 50.125 52 48 52C45.75 52 44 53.875 44 56C44 58.25 45.75 60 48 60C50.125 60 52 58.25 52 56ZM76 48C80.375 48 83.875 51.625 83.875 56C83.875 60.5 80.375 64 76 64C71.5 64 68 60.5 68 56C68 51.625 71.5 48 76 48ZM76 60C78.125 60 80 58.25 80 56C80 53.875 78.125 52 76 52C73.75 52 72 53.875 72 56C72 58.25 73.75 60 76 60ZM20 64C15.5 64 12 60.5 12 56C12 51.625 15.5 48 20 48C24.375 48 27.875 51.5 27.875 56C27.875 60.375 24.375 64 20 64ZM20 52C17.75 52 16 53.875 16 56C16 58.25 17.75 60 20 60C22.125 60 24 58.25 24 56C24 53.875 22.125 52 20 52ZM14 46C12.875 46 12 45.125 12 44V22C12 18.75 14.625 16 18 16.125H78C81.25 16.125 84 18.75 84 22V44C84 45.125 83 46 82 46C80.875 46 80 45.125 80 44V22C80 21 79 20 78 20H18C16.875 20 16 21 16 22V44C16 45.125 15 46 14 46Z" />
                        </svg>
                    </i>
                    <div class="box-content">
                        <h3 class="title">
                            Management
                        </h3>
                        <p class="sous-titre">
                            Coaching individuel et collectif, Conduite du changement, Accompagnement CODIR, Teambuilding,
                            Co-développement...
                        </p>
                    </div>
                </a>
                <a class="transition" href="/transition-professionnelle/outplacement">
                    <i>
                        <svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 24V72C12 74.25 13.75 76 16 76H24V68C24 63.625 27.5 60 32 60C36.375 60 40 63.625 40 68V76H48C48 77.5 48.375 78.875 49.125 80C48.75 80 48.375 80 48 80H16C11.5 80 8 76.5 8 72V24C8 19.625 11.5 16 16 16H48C52.375 16 56 19.625 56 24V62C54.375 62.875 53.125 64 52 65.25V24C52 21.875 50.125 20 48 20H16C13.75 20 12 21.875 12 24ZM36 68C36 65.875 34.125 64 32 64C29.75 64 28 65.875 28 68V76H36V68ZM16 31C16 29.375 17.25 28 19 28H25C26.625 28 28 29.375 28 31V37C28 38.75 26.625 40 25 40H19C17.25 40 16 38.75 16 37V31ZM20 32V36H24V32H20ZM45 28C46.625 28 48 29.375 48 31V37C48 38.75 46.625 40 45 40H39C37.25 40 36 38.75 36 37V31C36 29.375 37.25 28 39 28H45ZM44 36V32H40V36H44ZM16 47C16 45.375 17.25 44 19 44H25C26.625 44 28 45.375 28 47V53C28 54.75 26.625 56 25 56H19C17.25 56 16 54.75 16 53V47ZM20 48V52H24V48H20ZM45 44C46.625 44 48 45.375 48 47V53C48 54.75 46.625 56 45 56H39C37.25 56 36 54.75 36 53V47C36 45.375 37.25 44 39 44H45ZM44 52V48H40V52H44ZM80 50C80 55.625 75.5 60 70 60C64.375 60 60 55.625 60 50C60 44.5 64.375 40 70 40C75.5 40 80 44.5 80 50ZM70 44C66.625 44 64 46.75 64 50C64 53.375 66.625 56 70 56C73.25 56 76 53.375 76 50C76 46.75 73.25 44 70 44ZM76.25 64C82.75 64 88 69.25 88 75.75C88 78.125 86 80 83.625 80H56.25C53.875 80 52 78.125 52 75.75C52 69.25 57.125 64 63.625 64H76.25ZM56.25 76H83.625C83.75 76 84 75.875 84 75.75C84 71.5 80.5 68 76.25 68H63.625C59.375 68 56 71.5 56 75.75C56 75.875 56.125 76 56.25 76Z" />
                        </svg>
                    </i>
                    <div class="box-content">
                        <h3 class="title">
                            Transition professionnelle
                        </h3>
                        <p class="sous-titre">
                            Bilan de compétences, Formation, Outplacement, Bilan retraite...
                        </p>
                    </div>
                </a>
                <a class="recrutement" href="/recrutement/recrutement">
                    <i>
                        <svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M82.625 58.25C85.625 58.25 88 60.625 88 63.5V68.5C88 71.5 85.625 73.75 82.5 73.75H81.5V74.75C81.5 77.75 79.25 80 76.375 80H71.375C68.375 80 66.125 77.75 66.125 74.75V73.75H65.125C62.25 73.75 60 71.5 60 68.5V63.5C60 60.625 62.25 58.25 65.25 58.25H66.25V57.25C66.25 54.375 68.5 52 71.5 52H76.5C79.375 52 81.625 54.375 81.625 57.25V58.25H82.625ZM84 68.5V63.5C84 62.875 83.375 62.25 82.5 62.25H77.5V57.25C77.5 56.625 77 56 76.375 56H71.375C70.625 56 70.125 56.625 70.125 57.25V62.25H65.125C64.5 62.25 64 62.875 64 63.5V68.5C64 69.25 64.5 69.75 65.25 69.75H70.25V74.75C70.25 75.5 70.875 76 71.5 76H76.5C77.125 76 77.75 75.5 77.75 74.75V69.75H82.75C83.375 69.75 84 69.25 84 68.5ZM70 40H78.125C81.625 40 84.75 42 86.5 45C87.25 46.375 86.375 48 84.75 48C84 48 83.375 47.625 83 47C82 45.25 80.125 44 78.125 44H70C69.125 44 68.375 44.25 67.625 44.625C66.5 45.125 65.25 44.625 64.875 43.5C64.5 42.5 65 41.375 66 40.875C67.25 40.375 68.625 40 70 40ZM72 36C66.375 36 62 31.625 62 26C62 20.5 66.375 16 72 16C77.5 16 82 20.5 82 26C82 31.625 77.5 36 72 36ZM72 20C68.625 20 66 22.75 66 26C66 29.375 68.625 32 72 32C75.25 32 78 29.375 78 26C78 22.75 75.25 20 72 20ZM58 76C59 76 60 77 60 78C60 79.125 59 80 58 80H27.5C25.5 80 24 78.625 24 76.75C24 67.5 31.875 60 41.75 60H54C55 60 56 61 56 62C56 63.125 55 64 54 64H41.625C34.375 64 28.375 69.375 28 76H58ZM28.25 44.625C27.5 44.25 26.75 44 26 44H17.75C14.625 44 12 46.875 12 50.375V52C12 53.125 11 54 10 54C8.875 54 8 53.125 8 52V50.375C8 44.75 12.375 40 17.75 40H26C27.375 40 28.75 40.375 30 41C31 41.5 31.375 42.625 31 43.625C30.5 44.625 29.25 45.125 28.25 44.625ZM24 36C18.375 36 14 31.625 14 26C14 20.5 18.375 16 24 16C29.5 16 34 20.5 34 26C34 31.625 29.5 36 24 36ZM24 20C20.625 20 18 22.75 18 26C18 29.375 20.625 32 24 32C27.25 32 30 29.375 30 26C30 22.75 27.25 20 24 20ZM47.875 56C40.75 56 34.875 50.25 35 43C35 35.875 40.75 30 47.875 30C55 30 60.875 35.875 60.875 43C60.875 50.25 55.125 56 47.875 56ZM47.875 34C43 34 38.875 38.125 38.875 43C38.875 48 43 52 47.875 52C52.875 52 56.875 48 56.875 43C56.875 38.125 52.875 34 47.875 34Z" />
                        </svg>
                    </i>
                    <div class="box-content">
                        <h3 class="title">
                            Recrutement
                        </h3>
                        <p class="sous-titre">
                            Évaluation candidat, Recrutement, Approche directe, Assessment...
                        </p>
                    </div>
                </a>
            </div>
            <div class="icon-box-one">
                <i>
                    <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <ellipse cx="30.5" cy="30.8047" rx="30" ry="30" transform="rotate(90 30.5 30.8047)"
                            fill="#F4989D" />
                    </svg>
                </i>
            </div>
            <div class="icon-box-two">
                <i>
                    <svg width="99" height="87" viewBox="0 0 99 87" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M49.5 0.804688L98.8634 86.3047H0.136551L49.5 0.804688Z" fill="#FAB74B" />
                    </svg>
                </i>
            </div>
            <div class="icon-box-three">
                <i>
                    <svg width="95" height="95" viewBox="0 0 95 95" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="47.2854" y="2.2189" width="64.1646" height="64.1646" transform="rotate(45 47.2854 2.2189)"
                            stroke="#a3d6f5" stroke-width="2" fill="#044B94" fill-opacity="0.1" />
                    </svg>
                </i>
            </div>
            <div class="icon-box-four">
                <i>
                    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="21.5" cy="21.8047" r="21" transform="rotate(180 21.5 21.8047)" fill="#318EC7" />
                    </svg>
                </i>
            </div>
            <div class="icon-box-five">
                <i>
                    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="21.5" cy="21.8047" r="21" transform="rotate(180 21.5 21.8047)" fill="#318EC7" />
                    </svg>
                </i>
            </div>
            <div class="icon-box-six">
                <i>
                    <svg width="108" height="108" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="54.3496" width="75.7239" height="75.7239" transform="rotate(-45 0.5 54.3496)"
                            fill="#F4989D" />
                    </svg>
                </i>
            </div>
            <div class="icon-box-seven">
                <i>
                    <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1.91421" y="29.2539" width="38.234" height="38.234" transform="rotate(-45 1.91421 29.2539)"
                            stroke="#a3d6f5" stroke-width="2" fill="#044B94" fill-opacity="0.1" />
                    </svg>
                </i>
            </div>
            <div class="icon-box-eight">
                <i>
                    <svg width="70" height="61" viewBox="0 0 70 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M35 0.804681L69.208 60.0547L0.792006 60.0547L35 0.804681Z" fill="#FAB74B" />
                    </svg>
                </i>
            </div>
        </div>
    </section>
</template>


<script setup>

</script>

<style scoped>
svg ellipse,
path,
circle,
rect {
    fill: #a3d6f5 !important;
}

.icon-box-one,
.icon-box-two,
.icon-box-three,
.icon-box-four,
.icon-box-five,
.icon-box-six,
.icon-box-seven,
.icon-box-eight {
    background: transparent;
}

.icon-box-one {
    left: 8%
}

.icon-box-two {
    left: -2%
}

.icon-box-three {
    left: 5%
}

.icon-box-four {
    left: 5%;
    margin-left: -24px;
    margin-bottom: 53px;
}

.icon-box-five {
    right: 10%;
    top: 0%;
}

.icon-box-six {
    right: -1%;
    top: 13%;
}

.icon-box-seven {
    right: 5%;
    top: 37%;
}

.icon-box-eight {
    right: 2%;
    bottom: -2%;
}

.titre-section {
    color: var(--accent, #25233E);
    text-align: center;
    font-family: Nunito;
    font-size: 3.125rem;
    /*50 px */
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    letter-spacing: -0.825px;
    text-transform: uppercase;
}

.title {
    color: var(--accent, #25233E);
    font-family: Nunito;
    font-size: 1.875rem;
    font-style: normal;
    font-weight: 500;
    line-height: 111.5%;
    letter-spacing: -0.51px;
}

.sous-titre {
    color: var(--accent, #25233E);
    /* txt */
    font-family: Inter;
    font-size: 1.063rem;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
}

.box-card {
    margin-top: 60px;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(5, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
}

.conseil {
    grid-area: 1 / 1 / 4 / 3;
}

.qualite {
    grid-area: 1 / 3 / 4 / 5;
}

.management {
    grid-area: 1 / 5 / 4 / 7;
}

.transition {
    grid-area: 4 / 1 / 6 / 4;
}

.recrutement {
    grid-area: 4 / 4 / 6 / 7;
}

.box-card .conseil,
.box-card .qualite,
.box-card .management,
.box-card .transition,
.box-card .recrutement {
    background: white;
    margin: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 30px;
    border-radius: 0.5625rem;
}

.box-card .conseil:hover,
.box-card .qualite:hover,
.box-card .management:hover,
.box-card .transition:hover,
.box-card .recrutement:hover {
    background: linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%);
}

.box-card .conseil i svg,
.box-card .qualite i svg,
.box-card .management i svg,
.box-card .transition i svg,
.box-card .recrutement i svg {
    fill: #318EC7;
    /*transition: all .3s ease-in;*/
}

.box-card .conseil:hover i svg,
.box-card .qualite:hover i svg,
.box-card .management:hover i svg,
.box-card .transition:hover i svg,
.box-card .recrutement:hover i svg {
    fill: white;
}

.box-card .conseil:hover .sous-titre,
.box-card .conseil:hover .title,
.box-card .qualite:hover .sous-titre,
.box-card .qualite:hover .title,
.box-card .management:hover .sous-titre,
.box-card .management:hover .title,
.box-card .transition:hover .sous-titre,
.box-card .transition:hover .title,
.box-card .recrutement:hover .sous-titre,
.box-card .recrutement:hover .title {
    color: #fff;
}


.box-card img {
    max-width: 60px;
}

.section-padding {
    padding-bottom: 4rem;
}

.span-background-blue {
    font-family: Nunito;
    font-style: normal;
    font-weight: 600;
}

.box-content {
    text-align: left;
}


/* Styles pour les écrans de petite taille (S) */
@media only screen and (max-width: 599px) {
    .box-card .conseil,
    .box-card .qualite,
    .box-card .management,
    .box-card .transition,
    .box-card .recrutement {
        padding: 14px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .conseil,
    .qualite,
    .management,
    .transition,
    .recrutement {
        max-width: 100%;
        margin: 20px auto;
        box-sizing: border-box;
        text-align: center;
    }

    i svg {
        width: 50px !important;
        height: auto;
        margin-bottom: 10px;
    }

    .box-content {
        padding: 10px;
    }

    .title {
        line-height: 1.2;
    }

    .sous-titre {
        font-size: 0.6em;
        line-height: normal;
    }
}

@media screen and (max-width: 768px) {
    .box-card {
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(10, 1fr);
    }

    .conseil {
        grid-area: 1 / 1 / 3 / 4;
    }

    .qualite {
        grid-area: 3 / 1 / 5 / 4;
    }

    .management {
        grid-area: 5 / 1 / 7 / 4;
    }

    .transition {
        grid-area: 7 / 1 / 9 / 4;
    }

    .recrutement {
        grid-area: 9 / 1 / 11 / 4;
    }

    .add-padding.hero-banner-ten h3 {
        text-align: left;
    }

    .add-padding.hero-banner-ten p {
        text-align: left;
    }

    .icon-box-one,
    .icon-box-two,
    .icon-box-three,
    .icon-box-four,
    .icon-box-five,
    .icon-box-six,
    .icon-box-seven,
    .icon-box-eight {
        display: none;
    }
}

@media only screen and (min-width: 769px) and (max-width: 991px) {
    .box-card {
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(10, 1fr);
    }

    .conseil {
        grid-area: 1 / 1 / 3 / 4;
    }

    .qualite {
        grid-area: 3 / 1 / 5 / 4;
    }

    .management {
        grid-area: 5 / 1 / 7 / 4;
    }

    .transition {
        grid-area: 7 / 1 / 9 / 4;
    }

    .recrutement {
        grid-area: 9 / 1 / 11 / 4;
    }

    .add-padding.hero-banner-ten h3 {
        text-align: left;
    }

    .add-padding.hero-banner-ten p {
        text-align: left;
    }

    .icon-box-one,
    .icon-box-two,
    .icon-box-three,
    .icon-box-four,
    .icon-box-five,
    .icon-box-six,
    .icon-box-seven,
    .icon-box-eight {
        display: none;
    }
}

@media only screen and (min-width: 1000px) and (max-width: 1024px) {
    .box-card .conseil,
    .box-card .qualite,
    .box-card .management,
    .box-card .transition,
    .box-card .recrutement {
        padding: 14px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .conseil,
    .qualite,
    .management,
    .transition,
    .recrutement {
        max-width: 100%;
        margin: 20px auto;
        box-sizing: border-box;
        text-align: left;
    }

    i svg {
        width: 40px !important;
        height: auto;
        margin-bottom: 10px;
    }

    .box-content {
        padding: 10px;
    }

    .title {
        line-height: 1.5;
    }

    .sous-titre {
        font-size: 1em;
        line-height: normal;
    }
}

@media screen and (min-width: 320px) {

    h3,
    h3 .title {
        font-size: 1.3rem !important;
    }
}

@media screen and (min-width: 375px) {

    h3,
    h3 .title {
        font-size: 1.5rem !important;
    }
}

@media screen and (min-width: 425px) {

    h3,
    h3 .title {
        font-size: 1.5rem !important;
    }
}

@media screen and (min-width: 768px) {

    h3,
    h3 .title {
        font-size: 1.8rem !important;
    }
}

@media screen and (min-width: 1024px) {

    h3,
    h3 .title {
        font-size: 1.8rem !important;
    }
}

@media screen and (min-width: 1440px) {

    h3,
    h3 .title {
        font-size: 1.875rem !important;
    }
}

@media screen and (min-width: 2559px) {

    h3,
    h3 .title {
        font-size: 1.885rem !important;
    }
}


/** ecran 1280 * 1024  */

@media only screen and (min-width: 1088px) and (max-width: 1381px) {

    h3,
    h3 .title {
        font-size: 1.58rem !important;
    }

    .sous-titre[data-v-f414dcf7] {
        font-size: 0.863rem;
    }

    .box-card .conseil,
    .box-card .qualite,
    .box-card .management,
    .box-card .transition,
    .box-card .recrutement {
        gap: 1rem;
        padding: 20px;
    }

    i svg {
        width: 60px !important;
        height: auto;
        margin-bottom: 10px;

    }
}
</style>